import { Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';

@Component({
  selector: 'upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css'],
  providers: [HubService],
})

export class UploadFileComponent implements OnInit, OnChanges {
  selectedFile: any = null;
  public failFlag: boolean;

  isDisabled: boolean;
  isUploading: boolean;

  @Output() open_close = new EventEmitter<boolean>();

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.isDisabled=false;
    this.isUploading=false
    this.failFlag = false;
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  sendFlag() {
    this.open_close.emit(false);
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    console.log(this.selectedFile);
  }

  upload() {
    console.log('upload....');
    this.isDisabled = true;
    this.isUploading = true;
    this.hubService.uploadLeads(this.selectedFile)
      .subscribe(
        data => {
          this.isUploading = false;
          if (data.status != "success") {
            this.failFlag = true;
          } else {
            this.sendFlag();
          }
        },
        error => {
          console.log(error);
          this.isUploading = false;
          this.failFlag = true;
        }
      );
  }

}
